import axios from "axios";
import { BASE_URL } from "./urls";

const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

// ---------------- REQUEST INTERCEPTOR ----------------
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    console.log("🚀 ~ token:", token);

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// ---------------- RESPONSE INTERCEPTOR ----------------
apiClient.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      return response;
    }
    return response.data;
  },
  (error) => {
    const status = error.response?.status;

    if (status === 401) {
      localStorage.removeItem("authToken");
      // window.location.href = "/login";
    }

    if (status === 500) {
      console.error("Server error");
    }

    const res = error.response;
    if (
      res?.data instanceof Blob &&
      error.config?.responseType === "blob"
    ) {
      return res.data.text().then((text) => {
        let payload = text;
        try {
          payload = text ? JSON.parse(text) : text;
        } catch {
          /* keep raw text */
        }
        return Promise.reject(payload);
      });
    }

    return Promise.reject(error.response?.data || error.message);
  },
);

export default apiClient;
